import { Injectable, NgZone } from '@angular/core';
import { InactivePopup } from '@d-components/popup/inactive-popup/inactive-popup.component';
import { ModalSize } from '@d-constants';
import {
  Observable,
  fromEvent,
  merge,
  timer,
  takeUntil,
  repeat,
  Subscription,
  Subject,
} from 'rxjs';
import { ModalService } from '@d-services/other/modal.service';
import { HttpService } from '@d-services';

@Injectable()
export class CheckIdleService {
  INACTIVE_TIME = 15 * 60; // 15 minutes
  // INACTIVE_TIME = 5;
  inactivityTimerEvent: Array<any>[] = [
    [document, 'click'],
    [document, 'wheel'],
    [document, 'scroll'],
    [document, 'mousemove'],
    [document, 'keyup'],
    // [window, 'resize'],
    // [window, 'scroll'],
    // [window, 'mousemove'],
  ];

  inactiveSubscription$: Subscription | null = null;
  idle$ = new Subject<void>();

  constructor(private ngZone: NgZone) {
    let observableArray$: Observable<any>[] = [];
    this.inactivityTimerEvent.forEach((x) => {
      observableArray$.push(fromEvent(x[0], x[1]));
    });
    this.activeEvents$ = merge(...observableArray$);
  }

  activeEvents$!: Observable<any>;

  startTimer(autoUnsubscribe = false) {
    this.ngZone.runOutsideAngular(() => {
      if (!this.inactiveSubscription$) {
        this.inactiveSubscription$ = timer(0, 1000)
          .pipe(takeUntil(this.activeEvents$), repeat())
          .subscribe((value) => {
            this.ngZone.run(() => {
              if (value >= this.INACTIVE_TIME) {
                if (autoUnsubscribe) {
                  this.stopTimer();
                }
                this.idle$.next();
              }
            });
          });
      }
    });
  }

  stopTimer() {
    if (this.inactiveSubscription$) {
      this.inactiveSubscription$.unsubscribe();
      this.inactiveSubscription$ = null;
    }
  }
}
